import React from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Container, Card, Icon } from "@mui/material";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error inside React tree:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/dashboard";
  };

  render() {
    if (this.state.hasError) {
      return (
        <MDBox
          minHeight="100vh"
          width="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            background: "linear-gradient(135deg, #1A1C29 0%, #0F1016 100%)",
            color: "#ffffff",
          }}
        >
          <Container maxWidth="sm">
            <Card
              sx={{
                p: 4,
                textAlign: "center",
                background: "rgba(255, 255, 255, 0.05)",
                backdropFilter: "blur(20px)",
                borderRadius: "16px",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
              }}
            >
              <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="64px"
                height="64px"
                bgColor="error"
                coloredShadow="error"
                borderRadius="50%"
                mx="auto"
                mb={3}
              >
                <Icon fontSize="large" sx={{ color: "#fff" }}>
                  warning_amber
                </Icon>
              </MDBox>

              <MDTypography variant="h3" fontWeight="bold" color="white" mb={1}>
                Something went wrong
              </MDTypography>
              
              <MDTypography variant="button" color="text" display="block" mb={3} sx={{ color: "rgba(255,255,255,0.7)" }}>
                An unexpected application rendering error occurred.
              </MDTypography>

              {this.state.error && (
                <MDBox
                  bgColor="dark"
                  p={2}
                  borderRadius="lg"
                  mb={3}
                  sx={{
                    textAlign: "left",
                    maxHeight: "150px",
                    overflowY: "auto",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    border: "1px solid rgba(255,255,255,0.05)",
                  }}
                >
                  <MDTypography
                    variant="caption"
                    color="white"
                    component="pre"
                    sx={{
                      fontFamily: "monospace",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-all",
                    }}
                  >
                    {this.state.error.toString()}
                  </MDTypography>
                </MDBox>
              )}

              <MDBox display="flex" justifyContent="center" gap={2}>
                <MDButton color="info" onClick={this.handleReload} variant="gradient">
                  Reload Page
                </MDButton>
                <MDButton color="white" onClick={this.handleGoHome} variant="outlined">
                  Go to Dashboard
                </MDButton>
              </MDBox>
            </Card>
          </Container>
        </MDBox>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
